import { MembershipRolesEnum } from 'gql/types'

export const isClientManagerRole = (role: Maybe<MembershipRolesEnum>) => {
  if (!role) {
    return false
  }

  return [MembershipRolesEnum.CLIENT_MANAGER_ADMIN, MembershipRolesEnum.CLIENT_MANAGER_TEAM_MEMBER].includes(role)
}
